var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"city-path-container"},[_c('div',{staticClass:"path path1"}),_c('div',{staticClass:"path path2"})])}]

export { render, staticRenderFns }